import React from 'react';

class BackdropHandler extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.rootRef = React.createRef();
  }

  componentDidMount() {
    if (document.addEventListener) {
      // `useCapture` flag is set to true so that a `stopPropagation` in the children will
      // not prevent all outside click handlers from firing - maja
      document.addEventListener('click', this.onClick, true);
    } else {
      document.attachEvent('onclick', this.onClick);
    }
  }

  componentWillUnmount() {
    if (document.removeEventListener) {
      document.removeEventListener('click', this.onClick, true);
    } else {
      document.detachEvent('onclick', this.onClick);
    }
  }

  onClick(e) {
    const doNotWork          = !(this.props.doNotWork === true);
    const isDescendantOfRoot = this.rootRef.current.contains(e.target);
    const existsAlertModal   = document.getElementById('_stop_back_drop_handler_click_event_');
    if (
      !isDescendantOfRoot &&        // 내 자식 영역에서 클릭이벤트 발생한게 아니다.
      doNotWork                     // 다중으로 열린경우...
    ) {
      this.props.onClick(e);
    }
  }

  render() {
    return (
      <div ref={this.rootRef} className={this.props.className} style={this.props.style}>
        {this.props.children}
      </div>
    );
  }
}



export default BackdropHandler
